import React, { useEffect } from 'react';
import { useSpace } from '../Spaces/SpaceContext';
import { useEditItem2 } from '../../toolympus/api/useNewItem';
import { Button, Typography } from '@mui/material';
import { Buttons, FormGrid, OccupyFreeSpace } from '../../toolympus/components/primitives';
import { FormControlsForFields } from '../../toolympus/components/schemed';
import { ProjectFieldSchema } from '../Projects/ProjectsSettingsEdit';

interface Props {
  
}

export const ContactFieldsSettingKey = "_sb_contact_fields";
export const ContactFieldsKeys = [
  "custom_text1",
  "custom_text2",
  "custom_text3",
  "custom_text4",
  "custom_text5",
];


export const ContactsSettingsEdit = (props: Props) => {
  const { settings } = useSpace();
  const fieldsSettings = useEditItem2<Record<string, any>>({
    save: (item) => {
      return settings.update({ [ContactFieldsSettingKey]: item })
        .then(x => x[ContactFieldsSettingKey]);
    },
    dontResetOnSave: true,
  });

  useEffect(() => {
    fieldsSettings.startEditing(settings.settings[ContactFieldsSettingKey] || {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings.settings]);


  return (
    <>
      <Typography variant="h6">Атрибуты</Typography>
      {!!fieldsSettings.item && ContactFieldsKeys.map(k => {
        const field = (fieldsSettings.item || {})[k] || {};
        return (
          <FormGrid key={k} columns="2fr 4fr 1fr" alignItems="flex-end">
            <FormControlsForFields
              data={field}
              onChange={(o,c) => fieldsSettings.update({ [k]: { ...field, ...c }})}
              schema={ProjectFieldSchema}
              fields={[
                ["is_enabled"],
                field.is_enabled ? ["title"] : null,
                field.is_enabled ? ["sortorder"] : null,
              ]}
              />
          </FormGrid>
      )})}

      {fieldsSettings.hasChanges &&
        <Buttons>
          <OccupyFreeSpace />
          <Button size="small" color="primary" variant="contained" onClick={() => fieldsSettings.save()}>сохранить</Button>
        </Buttons>}
    </>
  );
}
